import { registerBlockType } from "@wordpress/blocks";
import {
    useBlockProps,
    InspectorControls,
    PanelColorSettings,
} from "@wordpress/block-editor";
import { useState } from "@wordpress/element";
import ReactDOMServer from "react-dom/server";

import {
    PanelBody,
    SelectControl,
    RangeControl,
    __experimentalView as View,
    Popover,
    Button,
    SearchControl,
    ToggleControl,
} from "@wordpress/components";

import UnitRange from "./components/UnitRange";

// Dodaj importy ikon MUI
import StarIcon from "@mui/icons-material/Star";
import FavoriteIcon from "@mui/icons-material/Favorite";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import AbcIcon from "@mui/icons-material/Abc";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import AccessibleIcon from "@mui/icons-material/Accessible";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";

// Actions
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AlarmIcon from "@mui/icons-material/Alarm";
import AlarmAddIcon from "@mui/icons-material/AlarmAdd";
import AlarmOffIcon from "@mui/icons-material/AlarmOff";

// Alert & Notification
import ErrorIcon from "@mui/icons-material/Error";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import WarningIcon from "@mui/icons-material/Warning";

// AV & Media
import FastForwardIcon from "@mui/icons-material/FastForward";
import FastRewindIcon from "@mui/icons-material/FastRewind";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";

// Communication
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import CallIcon from "@mui/icons-material/Call";
import ChatIcon from "@mui/icons-material/Chat";
import MessageIcon from "@mui/icons-material/Message";

// Content
import AddIcon from "@mui/icons-material/Add";
import CopyIcon from "@mui/icons-material/ContentCopy";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";

// Device & Hardware
import DevicesIcon from "@mui/icons-material/Devices";
import LaptopIcon from "@mui/icons-material/Laptop";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import TabletIcon from "@mui/icons-material/Tablet";
import TvIcon from "@mui/icons-material/Tv";

// Editor
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import FormatUnderlinedIcon from "@mui/icons-material/FormatUnderlined";
import LinkIcon from "@mui/icons-material/Link";

// File
import CloudIcon from "@mui/icons-material/Cloud";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FolderIcon from "@mui/icons-material/Folder";
import UploadFileIcon from "@mui/icons-material/UploadFile";

// Navigation
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RefreshIcon from "@mui/icons-material/Refresh";

// Social
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Dodaj import na górze pliku
import { CgMenuRight } from "react-icons/cg";
import { LuEarth } from "react-icons/lu";
import { IoClose } from "react-icons/io5";

// Dodaj mapowanie nazw ikon na nazwy Material Icons
const materialIconsMap = {
    star: "star",
    heart: "favorite",
    home: "home",
    settings: "settings",
    account: "account_circle",
    cart: "shopping_cart",
    menu: "menu",
    search: "search",
    email: "email",
    phone: "phone",
    location: "location_on",
    calendar: "calendar_today",
    arrowForward: "arrow_forward",
    arrowBack: "arrow_back",
    checkCircle: "check_circle",
    info: "info",
    abc: "abc",
    accessibility: "accessibility",
    accessible: "accessible",
    accountBalance: "account_balance",
    zoomIn: "zoom_in",
    zoomOut: "zoom_out",
    zoomOutMap: "zoom_out_map",
    // Actions
    addCircle: "add_circle",
    addCircleOutline: "add_circle_outline",
    alarm: "alarm",
    alarmAdd: "alarm_add",
    alarmOff: "alarm_off",
    // Alert & Notification
    error: "error",
    errorOutline: "error_outline",
    notifications: "notifications",
    notificationsActive: "notifications_active",
    warning: "warning",
    // AV & Media
    fastForward: "fast_forward",
    fastRewind: "fast_rewind",
    pause: "pause",
    playArrow: "play_arrow",
    stop: "stop",
    // Communication
    alternateEmail: "alternate_email",
    call: "call",
    chat: "chat",
    message: "message",
    // Content
    add: "add",
    copy: "content_copy",
    create: "create",
    delete: "delete",
    filterList: "filter_list",
    // Device & Hardware
    devices: "devices",
    laptop: "laptop",
    phoneAndroid: "phone_android",
    tablet: "tablet",
    tv: "tv",
    // Editor
    attachFile: "attach_file",
    formatBold: "format_bold",
    formatItalic: "format_italic",
    formatUnderlined: "format_underlined",
    link: "link",
    // File
    cloud: "cloud",
    cloudDownload: "cloud_download",
    cloudUpload: "cloud_upload",
    folder: "folder",
    uploadFile: "upload_file",
    // Navigation
    moreVert: "more_vert",
    refresh: "refresh",
    // Social
    facebook: "facebook",
    github: "github",
    instagram: "instagram",
    twitter: "twitter",
    youtube: "youtube",
};

// Obiekt mapujący nazwy ikon na komponenty
const iconComponents = {
    star: StarIcon,
    heart: FavoriteIcon,
    home: HomeIcon,
    settings: SettingsIcon,
    account: AccountCircleIcon,
    cart: ShoppingCartIcon,
    menu: MenuIcon,
    search: SearchIcon,
    email: EmailIcon,
    phone: PhoneIcon,
    location: LocationOnIcon,
    calendar: CalendarTodayIcon,
    arrowForward: ArrowForwardIcon,
    arrowBack: ArrowBackIcon,
    checkCircle: CheckCircleIcon,
    info: InfoIcon,
    abc: AbcIcon,
    accessibility: AccessibilityIcon,
    accessible: AccessibleIcon,
    accountBalance: AccountBalanceIcon,
    zoomIn: ZoomInIcon,
    zoomOut: ZoomOutIcon,
    zoomOutMap: ZoomOutMapIcon,

    // Actions
    addCircle: AddCircleIcon,
    addCircleOutline: AddCircleOutlineIcon,
    alarm: AlarmIcon,
    alarmAdd: AlarmAddIcon,
    alarmOff: AlarmOffIcon,

    // Alert & Notification
    error: ErrorIcon,
    errorOutline: ErrorOutlineIcon,
    notifications: NotificationsIcon,
    notificationsActive: NotificationsActiveIcon,
    warning: WarningIcon,

    // AV & Media
    fastForward: FastForwardIcon,
    fastRewind: FastRewindIcon,
    pause: PauseIcon,
    playArrow: PlayArrowIcon,
    stop: StopIcon,

    // Communication
    alternateEmail: AlternateEmailIcon,
    call: CallIcon,
    chat: ChatIcon,
    message: MessageIcon,

    // Content
    add: AddIcon,
    copy: CopyIcon,
    create: CreateIcon,
    delete: DeleteIcon,
    filterList: FilterListIcon,

    // Device & Hardware
    devices: DevicesIcon,
    laptop: LaptopIcon,
    phoneAndroid: PhoneAndroidIcon,
    tablet: TabletIcon,
    tv: TvIcon,

    // Editor
    attachFile: AttachFileIcon,
    formatBold: FormatBoldIcon,
    formatItalic: FormatItalicIcon,
    formatUnderlined: FormatUnderlinedIcon,
    link: LinkIcon,

    // File
    cloud: CloudIcon,
    cloudDownload: CloudDownloadIcon,
    cloudUpload: CloudUploadIcon,
    folder: FolderIcon,
    uploadFile: UploadFileIcon,

    // Navigation
    moreVert: MoreVertIcon,
    refresh: RefreshIcon,

    // Social
    facebook: FacebookIcon,
    github: GitHubIcon,
    instagram: InstagramIcon,
    twitter: TwitterIcon,
    youtube: YouTubeIcon,

    // Dodaj do obiektu iconComponents
    menuRight: CgMenuRight,
    luEarth: LuEarth,
    ioClose: IoClose,
};

const iconOptions = [
    // Basic
    { label: "ABC", value: "abc" },
    { label: "Dostępność", value: "accessibility" },
    { label: "Dostępne", value: "accessible" },
    { label: "Konto bankowe", value: "accountBalance" },
    { label: "Konto", value: "account" },
    { label: "Gwiazdka", value: "star" },
    { label: "Serce", value: "heart" },
    { label: "Dom", value: "home" },
    { label: "Ustawienia", value: "settings" },
    { label: "Koszyk", value: "cart" },
    { label: "Menu", value: "menu" },
    { label: "Szukaj", value: "search" },
    { label: "Email", value: "email" },
    { label: "Telefon", value: "phone" },
    { label: "Lokalizacja", value: "location" },
    { label: "Kalendarz", value: "calendar" },
    { label: "Zatwierdzone", value: "checkCircle" },
    { label: "Informacja", value: "info" },
    { label: "Przybliż", value: "zoomIn" },
    { label: "Oddal", value: "zoomOut" },
    { label: "Oddal mapę", value: "zoomOutMap" },

    // Actions
    { label: "Dodaj (okrąg)", value: "addCircle" },
    { label: "Dodaj (kontur)", value: "addCircleOutline" },
    { label: "Alarm", value: "alarm" },
    { label: "Dodaj alarm", value: "alarmAdd" },
    { label: "Wyłącz alarm", value: "alarmOff" },

    // Alert & Notification
    { label: "Błąd", value: "error" },
    { label: "Błąd (kontur)", value: "errorOutline" },
    { label: "Powiadomienia", value: "notifications" },
    { label: "Aktywne powiadomienia", value: "notificationsActive" },
    { label: "Ostrzeżenie", value: "warning" },

    // AV & Media
    { label: "Przewiń do przodu", value: "fastForward" },
    { label: "Przewiń do tyłu", value: "fastRewind" },
    { label: "Pauza", value: "pause" },
    { label: "Odtwórz", value: "playArrow" },
    { label: "Stop", value: "stop" },

    // Communication
    { label: "Email alternatywny", value: "alternateEmail" },
    { label: "Połączenie", value: "call" },
    { label: "Czat", value: "chat" },
    { label: "Wiadomość", value: "message" },

    // Content
    { label: "Dodaj", value: "add" },
    { label: "Kopiuj", value: "copy" },
    { label: "Utwórz", value: "create" },
    { label: "Usuń", value: "delete" },
    { label: "Lista filtrów", value: "filterList" },

    // Device & Hardware
    { label: "Urządzenia", value: "devices" },
    { label: "Laptop", value: "laptop" },
    { label: "Telefon Android", value: "phoneAndroid" },
    { label: "Tablet", value: "tablet" },
    { label: "TV", value: "tv" },

    // Editor
    { label: "Załącz plik", value: "attachFile" },
    { label: "Pogrubienie", value: "formatBold" },
    { label: "Kursywa", value: "formatItalic" },
    { label: "Podkreślenie", value: "formatUnderlined" },
    { label: "Link", value: "link" },

    // File
    { label: "Chmura", value: "cloud" },
    { label: "Pobierz z chmury", value: "cloudDownload" },
    { label: "Wgraj do chmury", value: "cloudUpload" },
    { label: "Folder", value: "folder" },
    { label: "Wgraj plik", value: "uploadFile" },

    // Navigation
    { label: "Strzałka w lewo", value: "arrowBack" },
    { label: "Strzałka w prawo", value: "arrowForward" },
    { label: "Więcej (pionowo)", value: "moreVert" },
    { label: "Odśwież", value: "refresh" },

    // Social
    { label: "Facebook", value: "facebook" },
    { label: "GitHub", value: "github" },
    { label: "Instagram", value: "instagram" },
    { label: "Twitter", value: "twitter" },
    { label: "YouTube", value: "youtube" },

    // Dodaj do tablicy iconOptions
    { label: "Menu prawe", value: "menuRight" },
    { label: "Globus", value: "luEarth" },
    { label: "Zamknij", value: "ioClose" },
];

registerBlockType("kamikaze/custom-icon", {
    apiVersion: 2,
    title: "Custom Icon",
    icon: "admin-customizer",
    category: "design",
    supports: {
        html: false,
        reusable: false,
    },
    attributes: {
        iconType: {
            type: "string",
            default: "star",
        },
        iconColor: {
            type: "string",
            default: "#000000",
        },
        iconSize: {
            type: "number",
            default: 24,
        },
        iconSizeUnit: {
            type: "string",
            default: "px",
        },
        rotation: {
            type: "number",
            default: 0,
        },
        opacity: {
            type: "number",
            default: 1,
        },
        svgCode: {
            type: "string",
            default: "",
        },
        display: {
            type: "string",
            default: "flex",
        },
        flexDirection: {
            type: "string",
            default: "column",
        },
        alignItems: {
            type: "string",
            default: "center",
        },
        gap: {
            type: "number",
            default: 0,
        },
        cursorPointer: {
            type: "boolean",
            default: false,
        },
    },

    edit: function CustomIconEdit({ attributes, setAttributes }) {
        const [isPopoverVisible, setIsPopoverVisible] = useState(false);
        const [searchTerm, setSearchTerm] = useState("");

        const blockProps = useBlockProps({
            className: "custom-icon",
            style: {
                color: attributes.iconColor,
                fontSize: attributes.iconSize + attributes.iconSizeUnit,
                width: attributes.iconSize + attributes.iconSizeUnit,
                height: attributes.iconSize + attributes.iconSizeUnit,
                transform: `rotate(${attributes.rotation}deg)`,
                opacity: attributes.opacity,
                display: attributes.display,
                flexDirection: attributes.flexDirection,
                alignItems: attributes.alignItems,
                gap: attributes.gap + "px",
                cursor: attributes.cursorPointer ? "pointer" : "default",
            },
        });

        const handleIconSelect = (icon) => {
            setAttributes({ iconType: icon.value });
            const IconComponent = iconComponents[icon.value];

            if (IconComponent) {
                // Pobierz surowy SVG z komponentu MUI
                const rawSvg = ReactDOMServer.renderToStaticMarkup(
                    <IconComponent />
                );

                // Wyczyść SVG z klas MUI i dodaj własne atrybuty
                const cleanedSvg = rawSvg
                    .replace(/class="[^"]*"/g, "")
                    .replace("<svg", `<svg fill="currentColor"`);

                setAttributes({ svgCode: cleanedSvg });
            }
            setIsPopoverVisible(false);
        };

        // Gdy zmienia się kolor, aktualizuj kod SVG
        const handleColorChange = (color) => {
            setAttributes({ iconColor: color });
            const IconComponent = iconComponents[attributes.iconType];
            if (IconComponent) {
                const svgCode = ReactDOMServer.renderToStaticMarkup(
                    <IconComponent
                        sx={{
                            color: color,
                            fontSize: "inherit",
                            width: "1em",
                            height: "1em",
                        }}
                        style={{
                            fill: color,
                        }}
                    />
                );
                setAttributes({ svgCode });
            }
        };

        const IconComponent = iconComponents[attributes.iconType];

        return (
            <>
                <InspectorControls>
                    <PanelBody title="Ustawienia ikony" initialOpen={true}>
                        <View style={{ padding: "15px" }}>
                            <UnitRange
                                rangeValue={attributes.iconSize}
                                onRangeChange={(value) =>
                                    setAttributes({ iconSize: value })
                                }
                                unitValue={{
                                    value: attributes.iconSize,
                                    unit: attributes.iconSizeUnit,
                                }}
                                onUnitChange={(newValue) => {
                                    setAttributes({
                                        iconSize: newValue.value,
                                        iconSizeUnit: newValue.unit,
                                    });
                                }}
                                label="Rozmiar ikony"
                                min={8}
                                max={200}
                            />

                            <RangeControl
                                label="Rotacja (stopnie)"
                                value={attributes.rotation}
                                onChange={(value) =>
                                    setAttributes({ rotation: value })
                                }
                                min={0}
                                max={360}
                                __nextHasNoMarginBottom={true}
                            />

                            <RangeControl
                                label="Przezroczystość"
                                value={attributes.opacity}
                                onChange={(value) =>
                                    setAttributes({ opacity: value })
                                }
                                min={0}
                                max={1}
                                step={0.1}
                                __nextHasNoMarginBottom={true}
                            />
                            <View style={{ paddingBottom: "15px" }}>
                                <ToggleControl
                                    label="Kursor wskaźnika"
                                    checked={attributes.cursorPointer}
                                    onChange={(value) =>
                                        setAttributes({ cursorPointer: value })
                                    }
                                    __nextHasNoMarginBottom={true}
                                />
                            </View>

                            <PanelColorSettings
                                title="Kolor ikony"
                                initialOpen={false}
                                enableAlpha={true}
                                colorSettings={[
                                    {
                                        value: attributes.iconColor,
                                        onChange: handleColorChange,
                                        label: "Kolor",
                                    },
                                ]}
                            />

                            <SelectControl
                                label="Wyświetlanie"
                                value={attributes.display}
                                options={[
                                    { label: "Flex", value: "flex" },
                                    { label: "Block", value: "block" },
                                    { label: "Inline", value: "inline" },
                                ]}
                                onChange={(value) =>
                                    setAttributes({ display: value })
                                }
                            />

                            <SelectControl
                                label="Kierunek flexa"
                                value={attributes.flexDirection}
                                options={[
                                    { label: "Kolumna", value: "column" },
                                    { label: "Wiersz", value: "row" },
                                ]}
                                onChange={(value) =>
                                    setAttributes({ flexDirection: value })
                                }
                            />

                            <SelectControl
                                label="Wyrównanie"
                                value={attributes.alignItems}
                                options={[
                                    { label: "Center", value: "center" },
                                    { label: "Start", value: "flex-start" },
                                    { label: "End", value: "flex-end" },
                                ]}
                                onChange={(value) =>
                                    setAttributes({ alignItems: value })
                                }
                            />

                            <RangeControl
                                label="Odległość (gap)"
                                value={attributes.gap}
                                onChange={(value) =>
                                    setAttributes({ gap: value })
                                }
                                min={0}
                                max={50}
                                step={1}
                            />
                        </View>
                    </PanelBody>
                </InspectorControls>
                <div {...blockProps}>
                    {IconComponent && (
                        <IconComponent
                            onClick={() => setIsPopoverVisible(true)}
                            style={{
                                fill: attributes.iconColor,
                                fontSize: "inherit",
                                width: "1em",
                                height: "1em",
                            }}
                        />
                    )}

                    {isPopoverVisible && (
                        <>
                            <Popover
                                className="icon-popover"
                                onClose={() => setIsPopoverVisible(false)}
                                position="bottom center"
                                focusOnMount="container"
                                expandOnMobile={true}
                                style={{
                                    padding: "0",
                                    background: "transparent",
                                }}
                            >
                                <div
                                    className="icon-popover-content"
                                    style={{
                                        padding: "16px",
                                        minWidth: "300px",
                                        maxHeight: "400px",
                                        overflow: "auto",
                                    }}
                                >
                                    <div style={{ marginBottom: "16px" }}>
                                        <SearchControl
                                            value={searchTerm}
                                            onChange={setSearchTerm}
                                            placeholder="Szukaj ikon..."
                                            __nextHasNoMarginBottom={true}
                                        />
                                    </div>
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns:
                                                "repeat(4, 1fr)",
                                            gap: "8px",
                                        }}
                                    >
                                        {iconOptions
                                            .filter((icon) =>
                                                icon.label
                                                    .toLowerCase()
                                                    .includes(
                                                        searchTerm.toLowerCase()
                                                    )
                                            )
                                            .map((icon) => (
                                                <Button
                                                    key={icon.value}
                                                    onClick={() =>
                                                        handleIconSelect(icon)
                                                    }
                                                    className="icon-button"
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        padding: "0",
                                                        cursor: "pointer",
                                                        border: "none",
                                                        background:
                                                            "transparent",
                                                    }}
                                                >
                                                    {React.createElement(
                                                        iconComponents[
                                                            icon.value
                                                        ],
                                                        {
                                                            style: {
                                                                fontSize:
                                                                    "24px",
                                                            },
                                                        }
                                                    )}
                                                </Button>
                                            ))}
                                    </div>
                                </div>
                            </Popover>
                        </>
                    )}
                </div>
            </>
        );
    },

    save: function CustomIconSave({ attributes }) {
        const blockProps = useBlockProps.save({
            className: "custom-icon",
            style: {
                color: attributes.iconColor,
                fontSize: attributes.iconSize + attributes.iconSizeUnit,
                width: attributes.iconSize + attributes.iconSizeUnit,
                height: attributes.iconSize + attributes.iconSizeUnit,
                transform: `rotate(${attributes.rotation}deg)`,
                opacity: attributes.opacity,
                display: attributes.display,
                flexDirection: attributes.flexDirection,
                alignItems: attributes.alignItems,
                gap: attributes.gap + "px",
                cursor: attributes.cursorPointer ? "pointer" : "default",
            },
        });

        return (
            <div
                {...blockProps}
                dangerouslySetInnerHTML={{ __html: attributes.svgCode }}
            />
        );
    },
});
